//@ts-nocheck
import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
  Box,
} from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import { useState } from "react";
import { TutorProfilePage } from "../_new_/components/tutor-profile/TutorProfilePage";
import { useSaveHook } from "./utils";

type Props = {
  tutor_profile: any;
  saveTutorInfo: (data: any) => Promise<any>;
  displayAlert?: boolean;
  isLiteTutor?: boolean;
  generateProfileSummary: (data: any) => Promise<any>;
};

const SpecialNeedsPage = ({
  tutor_profile,
  saveTutorInfo,
  isLiteTutor,
  generateProfileSummary,
}: Props) => {
  const { loading, onSubmitSection } = useSaveHook(saveTutorInfo);
  console.log("tutor_profile", tutor_profile);
  const {
    teachingProfile = {
      tutor_description: "",
      special_needs: {},
      academic_preferences: {},
      music_preferences: {},
      language_preferences: {},
    },
  } = tutor_profile || {};

  async function onSubmit(params: any) {
    if (params.academic_preferences) {
      params.curriculums = params.academic_preferences.curriculums;
    }
    const newData = {
      teachingProfile: { ...params },
    };
    const updated = await onSubmitSection(newData);
    const fromDashboard = window.location.search.includes("/dashboard/");
    if (newData.teachingProfile.tutor_description && fromDashboard) {
      window.location.href = "/dashboard";
    } else {
      return updated;
    }
  }
  async function onSubmitFormSection(field: string, data: any) {
    let payload: any = { [field]: data };
    if (field === "academic_preferences") {
      payload.curriculums = data?.curriculums || [];
    }
    if (field === "tutor_description") {
      payload = data;
    }
    return onSubmit(payload);
  }
  const displayAlert = Boolean(teachingProfile?.tutor_description) == false;

  return (
    <Box
      as="section"
      className="forms-section"
      maxW={["100%", "100%", "640px"]}
      px={[5, 8, 0]}
      py={[10, 12]}
      mx="auto"
    >
      {displayAlert && (
        <Box px={{ base: 5, md: 0 }}>
          <Alert
            status={"info"}
            variant="subtle"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            textAlign="center"
            height="200px"
            rounded="xl"
          >
            <AlertIcon boxSize="40px" mr={0} />
            <AlertTitle mt={4} mb={1} fontSize="lg">
              Update your tutor profile
            </AlertTitle>
            <AlertDescription maxWidth="sm">
              We've made changes to tutor profiles to help clients get more
              information about you. Please complete the sections below.
            </AlertDescription>
          </Alert>
        </Box>
      )}
      <TutorProfilePage
        tutor_profile={{ ...teachingProfile }}
        loading={loading}
        type="hide"
        onSubjectEdit={() => {}}
        navigateToSubject={onSubmit}
        children={() => <></>}
        displaySubmit={false}
        onSubmitFormSection={onSubmitFormSection}
        isLiteTutor={isLiteTutor}
        generateProfileSummary={generateProfileSummary}
      />
    </Box>
  );
};

export default observer(SpecialNeedsPage);
